import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { RpcAction, RpcExclusionItemsMethod, RpcExclusionItemToListMappings } from '../types';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export class GlobalExclusionsBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<any> {
    return {};
  }

  /**
   * Remove records
   * @param params
   */
  async removeRecords(params: any): Promise<{ success: boolean }> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        records: params,
      },
      endpoint: RpcAction.EXCLUSION_ITEMS,
      method: RpcExclusionItemsMethod.REMOVE_RECORDS,
    });
  }

  /**
   * Update records
   * @param params
   */
  async updateRecords(params: any): Promise<{ success: boolean }> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        records: params,
      },
      endpoint: RpcAction.EXCLUSION_ITEMS,
      method: RpcExclusionItemsMethod.UPDATE_RECORDS,
    });
  }

  async assignItemToMultipleLists(companyId, itemId, listsIds, override): Promise<{ success: boolean }> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        companyId: companyId,
        itemId: itemId,
        listsIds: listsIds,
        override: override,
      },
      endpoint: RpcAction.EXCLUSION_ITEM_TO_LIST_MAPPINGS,
      method: RpcExclusionItemToListMappings.ASSIGN_ITEM_TO_MULTIPLE_LISTS,
    });
  }

  async assignMultipleItemsToMultipleLists(companyId, itemIds, listIds): Promise<{ success: boolean }> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        companyId: companyId,
        itemIds: itemIds,
        listIds: listIds,
      },
      endpoint: RpcAction.EXCLUSION_ITEM_TO_LIST_MAPPINGS,
      method: RpcExclusionItemToListMappings.ASSIGN_MULTIPLE_ITEMS_TO_MULTIPLE_LISTS,
    });
  }
}
